<div class="well-detail-container">
    <!-- Well Header with Dropdown and Back Button -->
    <div class="section-header">
        <div class="well-header-row">
            <div class="well-title">
                <h3>Well: {{ wellName }}</h3>
                <span class="schema-subtitle">
                    {{ getActiveSchemaCount() }} Schema(s) are active for {{ wellName }}
                </span>
            </div>
            
            <div class="well-header-actions">
                <!-- Custom Dropdown for Supported Documents -->
                <div class="dropdown-container-custom dropdown-supported-documents">
                    <app-custom-dropdown
                        [options]="getDocumentTypeOptions()"
                        [value]="getSelectedDocLabel()"
                        placeholder="-- Select document --"
                        label="Supported Documents"
                        [loading]="loadingWellFiles"
                        (selectionChange)="onSupportedDocChange($event)">
                    </app-custom-dropdown>
                </div>

                <button class="btn btn-bulk-ingest" (click)="onBulkIngestClick()">
                    <span class="material-icons">arrow_upward</span>
                    Bulk Ingest
                </button>

                <button class="btn btn-back-to-list" (click)="navigateBackToList()">
                    <span class="material-icons">arrow_back</span>
                    Back to List
                </button>
            </div>
        </div>

        <div class="well-files-list" *ngIf="wellFiles.length > 0 && !loadingWellFiles">
           
        </div>
    </div>

    <!-- Loading Schemas -->
    <div class="loading-schemas" *ngIf="loadingSchemas">
        <div class="spinner-small"></div>
        <p>Loading schemas for {{ wellName }}...</p>
    </div>

    <!-- Schemas Section -->
    <div class="schemas-section" *ngIf="processedSchemas.length > 0 && !loadingSchemas && !showReview">
        <div class="schemas-list">
            <div class="schemas-stepper">
                <div 
                    class="schema-step" 
                    *ngFor="let schema of processedSchemas; let i = index; let isLast = last"
                    [class.selected]="selectedSchema === schema.displayName"
                    [class.disabled]="!schema.enabled"
                    [class.completed]="schema.completed"
                    (click)="!schema.enabled || loadingSchemaData ? null : onSchemaSelect(schema)">
                    <div class="step-content">
                        <div class="schema-circle" 
                             [class.enabled]="schema.enabled"
                             [class.completed]="schema.completed">{{ i + 1 }}</div>
                        <div class="schema-label">{{ schema.displayName }}</div>
                    </div>
                    <div class="schema-connector" *ngIf="!isLast"></div>
                </div>
            </div>
        </div>
        <div class="schema-progress">
            <span class="progress-text">Schema completion</span>
            <div class="progress-bar-container">
                <div class="progress-bar-fill" [style.width.%]="getProgressPercentage()"></div>
            </div>
            <span class="progress-label">{{ getCompletedSchemasCount() }} / {{ getActiveSchemaCount() }} schemas complete</span>
        </div>
    </div>

    <!-- Skeleton Loader for Schema Data Table -->
    <div class="schema-data-container" *ngIf="loadingSchemaData && selectedSchema && !showReview">
        <div class="schema-data-section">
            <div class="section-header">
                <div class="header-left">
                    <h3>Schema Data: {{ wellName }} - {{ selectedSchema }}</h3>
                    <p class="sections-count">Loading records...</p>
                </div>
            </div>
            
            <div class="schema-table-card">
                <div class="table-wrapper">
                    <table class="schema-table skeleton-table">
                        <thead>
                            <tr>
                                <th class="actions-col">
                                    <div class="skeleton skeleton-text"></div>
                                </th>
                                <th *ngFor="let col of [1,2,3,4,5,6,7]">
                                    <div class="skeleton skeleton-text"></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of [1,2,3,4,5]">
                                <td class="actions-col">
                                    <div class="skeleton-actions">
                                        <div class="skeleton skeleton-circle"></div>
                                        <div class="skeleton skeleton-circle"></div>
                                    </div>
                                </td>
                                <td *ngFor="let col of [1,2,3,4,5,6,7]">
                                    <div class="skeleton skeleton-text"></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <!-- Schema Data Container -->
    <div class="schema-data-container" 
         [class.with-preview]="selectedImageUrl || loadingImage || previewError"
         *ngIf="selectedSchema && schemaData && !loadingSchemaData">
        <div class="schema-data-section" *ngIf="!showReview">
            <div class="section-header">
                <div class="header-left">
                    <h3>Schema Data: {{ wellName }} - {{ selectedSchema }}</h3>
                    <p *ngIf="schemaDataSections.length > 0" class="sections-count">
                        {{ schemaDataSections.length }} record(s) found
                    </p>
                </div>
            </div>
            
            <!-- Schema Data Table -->
            <div class="schema-table-card" *ngIf="schemaDataSections.length > 0">
                <div class="table-wrapper">
                    <table class="schema-table">
                        <thead>
                            <tr>
                                <th class="actions-col">Actions</th>
                                <th *ngFor="let key of displayKeys">{{ getDisplayLabel(key) }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let section of schemaDataSections; let sectionIndex = index"
                                [class.has-changes]="sectionHasChanges[sectionIndex]">
                                <td class="actions-col">
                                    <div class="action-buttons">
                                        <button class="action-icon-btn edit-btn" [class.active]="sectionEditMode[sectionIndex]"
                                            [title]="sectionEditMode[sectionIndex] ? 'Cancel edit' : 'Edit row'"
                                            [disabled]="isSaving || isEditDisabledForSection(sectionIndex)"
                                            (click)="toggleEditMode(sectionIndex)">
                                            <span class="material-icons" *ngIf="!sectionEditMode[sectionIndex]">edit</span>
                                            <span class="material-icons" *ngIf="sectionEditMode[sectionIndex]">close</span>
                                        </button>
                                        <button class="action-icon-btn delete-btn" title="Delete row" [disabled]="isSaving || isDeleteDisabledForSection(sectionIndex)" (click)="deleteRecord(sectionIndex)">
                                            <span class="material-icons">delete</span>
                                        </button>
                                    </div>
                                </td>
                                <!-- IMPORTANT: iterate over global displayKeys -->
                                <td *ngFor="let key of displayKeys" class="editable-cell"
                                    [class.read-only]="getDisplayLabel(key) === 'Proposed Run' || getDisplayLabel(key) === 'Phase Number' || isFieldReadOnly(key) || !fieldExistsInSection(section, key)"
                                    [class.edit-mode]="sectionEditMode[sectionIndex]" [class.modified]="fieldHasChanges(sectionIndex, key)"
                                    [class.has-image]="fieldExistsInSection(section, key) && hasImage(section, key)" 
                                    [class.no-image]="!fieldExistsInSection(section, key) || !hasImage(section, key)"
                                    (click)="fieldExistsInSection(section, key) ? onCellClick(section, key) : null">
                                    <!-- Editable content (default) -->
                                    <div class="cell-content"
                                        *ngIf="getDisplayLabel(key) !== 'Proposed Run' && getDisplayLabel(key) !== 'Phase Number'">
                                        <span class="material-icons image-indicator" 
                                            *ngIf="fieldExistsInSection(section, key)"
                                            [class.has-image]="hasImage(section, key)"
                                            [class.no-image]="!hasImage(section, key)"
                                            [title]="hasImage(section, key) ? 'Click to view image' : 'No image attached'">
                                            insert_photo
                                        </span>
                                        
                                        <!-- Dropdown for enum/dropdown fields -->
                                        <div *ngIf="!isDateField(key) && isDropdownField(key)" class="dropdown-wrapper dropdown-table-field">
                                            <!-- Custom dropdown component -->
                                            <app-custom-dropdown
                                                [options]="getDropdownOptions(key)"
                                                [value]="section.editableData?.[key] || ''"
                                                [placeholder]="'-- Select ' + getDisplayLabel(key) + ' --'"
                                                [disabled]="!sectionEditMode[sectionIndex] || isFieldReadOnly(key)"
                                                (selectionChange)="updateSectionField(sectionIndex, key, $event)"
                                                (click)="$event.stopPropagation()">
                                            </app-custom-dropdown>
                                        </div>

                                        <!-- Text input for regular fields -->
                                        <input *ngIf="!isDateField(key) && !isDropdownField(key)" 
                                            [type]="(fieldTypeMap[key] === 'int' || fieldTypeMap[key] === 'float') ? 'number' : 'text'" 
                                            class="cell-input" [value]="(section.editableData?.[key] ?? '')"
                                            [title]="(section.editableData?.[key] ?? '')"
                                            (input)="updateSectionField(sectionIndex, key, $event.target.value)"
                                            (click)="$event.stopPropagation()"
                                            [disabled]="!sectionEditMode[sectionIndex] || isFieldReadOnly(key)"
                                            [placeholder]="'Enter ' + getDisplayLabel(key).toLowerCase()"
                                            [step]="fieldTypeMap[key] === 'float' ? 'any' : (fieldTypeMap[key] === 'int' ? '1' : null)">
                                        
                                        <!-- Date-Time input for date fields -->
                                        <div *ngIf="isDateField(key)" class="date-time-wrapper">
                                            <!-- RBU: datetime-local (includes time) -->
                                            <input *ngIf="bu === 'RBU'" type="datetime-local" 
                                                step="1"
                                                class="cell-input datetime-input" 
                                                [value]="formatForDateTimeInput(section.editableData?.[key])"
                                                (input)="onDateTimeInputChange(sectionIndex, key, $event.target.value)"
                                                (click)="$event.stopPropagation()"
                                                [disabled]="!sectionEditMode[sectionIndex] || isFieldReadOnly(key)"
                                                [title]="(section.editableData?.[key] ?? '-')"
                                                placeholder="Select date & time">
                                            
                                            <!-- ABU: date-only input (no time) -->
                                            <input *ngIf="bu === 'ABU'" type="date" 
                                                class="cell-input date-input" 
                                                [value]="formatForDateInput(section.editableData?.[key])"
                                                (input)="onDateInputChange(sectionIndex, key, $event.target.value)"
                                                (click)="$event.stopPropagation()"
                                                [disabled]="!sectionEditMode[sectionIndex] || isFieldReadOnly(key)"
                                                [title]="(section.editableData?.[key] ?? '-')"
                                                placeholder="Select date">
                                            
                                            <!-- Calendar icon -->
                                            <span class="material-icons datetime-icon" 
                                                *ngIf="!sectionEditMode[sectionIndex] || isFieldReadOnly(key) || !fieldExistsInSection(section, key)">
                                                calendar_today
                                            </span>
                                        </div>
                        
                                        <button class="undo-cell-btn"
                                            *ngIf="fieldHasChanges(sectionIndex, key) && sectionEditMode[sectionIndex]" title="Undo changes"
                                            (click)="undoFieldChanges(sectionIndex, key); $event.stopPropagation()">
                                            ↩
                                        </button>
                                    </div>                        
                                    <!-- Read-only cells with fallback -->
                                    <div class="cell-content read-only-content" *ngIf="getDisplayLabel(key) === 'Proposed Run'">
                                        <span class="material-icons image-indicator" 
                                            *ngIf="fieldExistsInSection(section, key)"
                                            [class.has-image]="hasImage(section, key)"
                                            [class.no-image]="!hasImage(section, key)"
                                            [title]="hasImage(section, key) ? 'Click to view image' : 'No image attached'">
                                            insert_photo
                                        </span>
                                        <span class="read-only-text">{{ section.editableData?.[key] || '-' }}</span>
                                    </div>                        
                                    <div class="cell-content read-only-content" *ngIf="getDisplayLabel(key) === 'Phase Number'">
                                        <span class="material-icons image-indicator" 
                                            *ngIf="fieldExistsInSection(section, key)"
                                            [class.has-image]="hasImage(section, key)"
                                            [class.no-image]="!hasImage(section, key)"
                                            [title]="hasImage(section, key) ? 'Click to view image' : 'No image attached'">
                                            insert_photo
                                        </span>
                                        <span class="read-only-text">{{ section.editableData?.[key] || '-' }}</span>
                                    </div>                       
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div class="table-footer">
                    <button class="add-record-btn" 
                            (click)="addNewRecord()"
                            [title]="'Add new record'">
                        <span class="material-icons">add</span>
                        Add Record
                    </button>
                    <div class="right-actions">
                        <button 
                            class="save-all-btn" 
                            [class.saving]="isSaving"
                            (click)="saveAllChanges()"
                            [disabled]="!hasAnyChanges()">
                            <span class="spinner-mini" *ngIf="isSaving"></span>
                            <span class="material-icons" *ngIf="!isSaving">save</span>
                            {{ isSaving ? 'Saving...' : 'Save All Changes' }}
                        </button>
                        <button 
                            class="next-btn" 
                            (click)="onNext()"
                            [disabled]="isSaving || isAnyEditModeActive()"
                            [title]="isSaving ? 'Saving...' : isAnyEditModeActive() ? 'Please save or cancel editing before proceeding' : 'Proceed to review'">
                            <span class="material-icons">arrow_forward</span>
                            Next
                        </button>
                    </div>
                </div>
            </div>
            
            <div class="no-data-message" *ngIf="schemaDataSections.length === 0 && displayKeys.length === 0">
                <div class="no-data-content">
                    <span class="material-icons" style="font-size: 64px; color: #cbd5e1;">description</span>
                    <p>No editable data fields available for this schema.</p>
                    <p class="hint">Select a different schema or add a new record to get started.</p>
                </div>
            </div>
        </div>
        
        <!-- Review Wrapper -->
        <div class="review-wrapper" *ngIf="showReview" style="height: 100%; overflow: auto;">
            <review-changes
                [wellName]="wellName"
                [wellIda]="wellName"
                [bu]="bu"
                [schemaType]="selectedSchemaApiName"
                [changedRecords]="reviewData.changedRecords"
                [displayKeys]="displayKeys"
                (back)="onReviewBack()"
                (submit)="onReviewSubmit()">
            </review-changes>
        </div>

        <!-- Image/Document Preview Section -->
        <div class="preview-section" 
             *ngIf="selectedImageUrl || loadingImage || previewError"
             [class.pdf-preview]="previewDocumentType === 'pdf'">
            <div class="preview-header">
                <h3>{{ previewDocumentTitle }}</h3>
                <button class="close-preview-btn" (click)="closePreview()" title="Close">
                    <span class="material-icons">close</span>
                </button>
            </div>
            <div class="preview-content">
                <div *ngIf="loadingImage" class="preview-loading">
                    <div class="spinner-small"></div>
                    <p>Loading preview...</p>
                </div>
                <div *ngIf="previewError && !loadingImage" class="preview-error">
                    <span class="material-icons" style="font-size: 80px; color: #ef4444;">error</span>
                    <p class="error-title">{{ previewError }}</p>
                </div>
                <div *ngIf="selectedImageUrl && !loadingImage && !previewError && previewDocumentType === 'image'" class="preview-wrapper">
                    <div class="image-container">
                        <div style="position: relative; display: inline-block;">
                            <img [src]="selectedImageUrl" 
                                 alt="Preview" 
                                 class="preview-image" 
                                 [style.transform]="'scale(' + (imageZoomLevel / 100) + ')'" 
                                 (click)="expandImage()" 
                                 (load)="onImageLoad($event)" />
                            <svg *ngIf="selectedFieldPolygon" 
                                 style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; transform-origin: center center;"
                                 [style.transform]="'scale(' + (imageZoomLevel / 100) + ')'"
                                 [attr.viewBox]="imageViewBox">
                                <polygon [attr.points]="selectedFieldPolygon" 
                                         fill="rgba(255, 255, 0, 0.2)" 
                                         stroke="red" 
                                         stroke-width="5" />
                            </svg>
                        </div>
                    </div>
                    <div class="preview-footer">
                        <div class="preview-caption">
                            <span (click)="expandImage()" style="cursor: pointer;">Click image to expand</span>
                            <button class="icon-btn-inline" 
                                    title="Open in new tab">
                                <span class="material-icons">open_in_new</span>
                            </button>
                        </div>
                    </div>
                    <div class="zoom-controls">
                        <button class="zoom-btn" 
                                (click)="zoomOut()" 
                                [disabled]="imageZoomLevel <= minZoom"
                                title="Zoom out">
                            <span class="material-icons">remove</span>
                        </button>
                        <span class="zoom-level">{{ imageZoomLevel }}%</span>
                        <button class="zoom-btn" 
                                (click)="resetZoom()" 
                                title="Reset zoom">
                            <span class="material-icons">refresh</span>
                        </button>
                        <button class="zoom-btn" 
                                (click)="zoomIn()" 
                                [disabled]="imageZoomLevel >= maxZoom"
                                title="Zoom in">
                            <span class="material-icons">add</span>
                        </button>
                    </div>
                </div>
                <div *ngIf="selectedImageUrl && !loadingImage && !previewError && previewDocumentType === 'pdf'" class="preview-wrapper">
                    <div class="pdf-container">
                        <iframe 
                            [src]="selectedImageUrl | safe: 'resourceUrl'" 
                            class="preview-pdf">
                        </iframe>
                    </div>
                    <div class="preview-footer">
                        <div class="preview-caption">
                            <span (click)="expandImage()" style="cursor: pointer;">Click PDF to expand</span>
                            <button class="icon-btn-inline" 
                                    title="Open in new tab">
                                <span class="material-icons">open_in_new</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Logs Section -->
    <div class="logs-section" *ngIf="selectedSchema && !showReview">
        <div class="section-header">
            <h3>
                Engineer suggestion logs for {{ wellName }}
                <span class="logs-summary-text" *ngIf="showLogsTable && suggestionsLogs.length > 0">
                    [Showing all {{ suggestionsLogs.length }} log {{ suggestionsLogs.length === 1 ? 'entry' : 'entries' }}]
                </span>
            </h3>
            <div class="logs-actions" *ngIf="!showLogsTable">
                <button class="logs-btn logs-btn-show" (click)="toggleLogsDisplay()">
                    <span class="material-icons">visibility</span>
                    Show Logs
                </button>
            </div>
        </div>

        <div class="loading-logs" *ngIf="loadingLogs">
            <div class="spinner-small"></div>
            <p>Loading logs...</p>
        </div>
        <div class="logs-table-container" *ngIf="!loadingLogs && showLogsTable">
            <div class="logs-table-wrapper" *ngIf="suggestionsLogs.length > 0">
                <table class="logs-table">
                    <thead>
                        <tr>
                            <th class="schema-column">Schema Type</th>
                            <th class="row-column">Record</th>
                            <th class="field-column">Field</th>
                            <th>Old Value</th>
                            <th>New Value</th>
                            <th class="timestamp-column">Timestamp</th>
                            <th class="user-column">User ID</th>
                            <th class="action-column">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let log of suggestionsLogs"
                            [class.action-deleted]="log.action === 'deleted'"
                            [class.action-updated]="log.action === 'updated'"
                            [class.action-created]="log.action === 'created'"
                            [class.action-viewed]="log.action === 'viewed'">
                            <td class="schema-type schema-column">{{ log.schema_type || '-' }}</td>
                            <td class="row-number row-column">{{ log.row || '-' }}</td>
                            <td class="field-name field-column">{{ log.field || '-' }}</td>
                            <td class="old-value" [title]="log.old_value || '-'">{{ formatLogValue(log.old_value) }}</td>
                            <td class="new-value" [title]="log.new_value || '-'">{{ formatLogValue(log.new_value) }}</td>
                            <td class="timestamp timestamp-column">{{ formatTimestamp(log.timestamp) }}</td>
                            <td class="user-id user-column">{{ log.user_id || '-' }}</td>
                            <td class="action action-column">
                                <span class="action-badge" [ngClass]="'action-' + log.action">
                                    {{ log.action }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div class="no-logs" *ngIf="suggestionsLogs.length === 0">
                <p>No suggestions logs found for this well and schema.</p>
                <p class="secondary-message">Try selecting a different well or schema, or refresh the logs.</p>
            </div>
            
            <div class="logs-footer">
                <div class="logs-footer-actions">
                    <button class="logs-btn logs-btn-show" (click)="toggleLogsDisplay()">
                        <span class="material-icons">visibility_off</span>
                        Hide Logs
                    </button>
                    <button class="logs-btn logs-btn-refresh" (click)="loadRecentSuggestionsLogs()" [disabled]="loadingLogs">
                        <span class="material-icons">refresh</span>
                        Refresh Logs
                    </button>
                </div>
            </div>
        </div>
    </div>



    <!-- Fill Comments Popup (for bulk ingest preparation) -->
    <app-fill-comments
        *ngIf="showFillCommentsPopup"
        [wellName]="wellName"
        [processedSchemas]="processedSchemas"
        (closed)="closeFillCommentsPopup()"
        (confirmedProceed)="onFillCommentsSaved()">
    </app-fill-comments>

    <!-- Snackbar Notification -->
    <div class="snackbar" 
         *ngIf="error" 
         [class.success]="notificationType === 'success'"
         [class.error]="notificationType === 'error'"
         [class.info]="notificationType === 'info'">
        <span class="snackbar-icon material-icons" *ngIf="notificationType === 'success'">check_circle</span>
        <span class="snackbar-icon material-icons" *ngIf="notificationType === 'error'">error</span>
        <span class="snackbar-icon material-icons" *ngIf="notificationType === 'info'">info</span>
        <span class="snackbar-message">{{ error }}</span>
        <button class="snackbar-close" (click)="error = ''">
            <span class="material-icons">close</span>
        </button>
    </div>
</div>
